import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { API } from '../App';
import './Layout.css';

const LANGUAGES = [
  { code: 'fr', flag: '🇫🇷' },
  { code: 'en', flag: '🇬🇧' },
  { code: 'es', flag: '🇪🇸' },
];

export default function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { instance, accounts } = useMsal();
  const { t, i18n } = useTranslation();

  // Solde de crédits (= consultations restantes) affiché en permanence dans le
  // header. Re-fetché à chaque changement de page pour que le nombre baisse
  // visiblement après la création d'un patient / d'une consultation.
  const practitionerId = (accounts[0]?.localAccountId || '').split(':')[0];
  const [subscription, setSubscription] = useState(null);
  useEffect(() => {
    if (!practitionerId) return;
    fetch(`${API}/api/stripe/subscription/${practitionerId}`)
      .then(r => r.json())
      .then(setSubscription)
      .catch(() => {});
  }, [practitionerId, location.pathname]);

  const hasPlan = subscription?.status === 'active';
  // credits_total = quota mensuel + crédits offerts (cf. bonus_credits côté
  // backend) : un seul solde affiché, la distinction est interne.
  const credits = subscription?.credits_total ?? subscription?.credits_remaining ?? 0;

  const handleLogout = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
  };

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('lang', code);
  };

  const userEmail = accounts[0]?.username || '';

  return (
    <div className="shell">
      <nav className="topnav">
        <button className="nav-logo" onClick={() => navigate('/')}>
          <span className="logo-sq">PA</span>
          <span className="logo-name">
            <span>PODO</span><span className="logo-sub">ANALYSIS</span>
          </span>
        </button>

        <div className="nav-links">
          <NavLink to="/" end className={({isActive}) => isActive ? 'nl active' : 'nl'}>
            {t('nav.patients')}
          </NavLink>
          <NavLink to="/patient/new/admin" className={({isActive}) => isActive ? 'nl active' : 'nl'}>
            {t('nav.new_patient')}
          </NavLink>
        </div>

        <div className="nav-user">
          <NavLink
            to="/subscription"
            className={({isActive}) =>
              `credits-badge${isActive ? ' active' : ''}${hasPlan && credits <= 5 ? ' low' : ''}`}
            title={t('nav.credits_title', 'Voir mon abonnement et mes crédits')}
          >
            {subscription == null ? (
              '…'
            ) : hasPlan ? (
              <>
                <span className="credits-num">{credits}</span>
                <span className="credits-label">{t('nav.credits', 'crédits')}</span>
              </>
            ) : (
              t('nav.subscribe', 'Abonnement')
            )}
          </NavLink>
          <div className="lang-switcher">
            {LANGUAGES.map(l => (
              <button
                key={l.code}
                className={`lang-switch-btn ${i18n.language === l.code ? 'active' : ''}`}
                onClick={() => changeLanguage(l.code)}
                title={l.code.toUpperCase()}
              >
                {l.flag}
              </button>
            ))}
          </div>
          <span className="user-email">{userEmail}</span>
          <button className="btn-logout" onClick={handleLogout}>{t('nav.logout')}</button>
        </div>
      </nav>

      <div className="page-content">
        {children}
      </div>
    </div>
  );
}